module.exports = __webpack_public_path__ + "img/bxs-share1.dfe40a34.svg";